<template>
  <div class="exchange-footer-loader loading">
    <div
        class="exchange-footer-loader__subscript-first loading__item"
    ></div>
    <div
        class="exchange-footer-loader__subscript-second loading__item"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ExchangeFooterLoader',
};
</script>
<style lang="scss">
@import "@scss-vars";

.exchange-footer-loader {
  font-size: rem(18);
  line-height: 1.33;

  &__subscript-first,
  &__subscript-second {
    display: block;
    height: rem(20);
  }

  &__subscript-first {
    width: rem(226);
    margin: 0 auto;
  }

  &__subscript-second {
    width: rem(282);
    margin: rem(4) auto 0 auto;
  }
}
</style>
